<template>
  <div class="qsn-page">
    <div class="qsn-page__container">
      <h1 class="qsn-page__title">青少年模式</h1>
      
      <div class="qsn-page__card">
        <div class="qsn-page__card-header">
          <div class="qsn-page__status" :class="{ 'qsn-page__status--active': isTeenMode }">
            <div class="qsn-page__status-circle"></div>
            <span>{{ isTeenMode ? '已开启' : '已关闭' }}</span>
          </div>
        </div>
        
        <div class="qsn-page__card-body">
          <div v-if="!isTeenMode">
            <p class="qsn-page__desc">青少年模式旨在保护未成年人健康上网，开启后将限制使用时长、过滤不良内容、禁止开通会员。</p>
            
            <div class="qsn-page__features">
              <h3 class="qsn-page__features-title">开启后将启用以下保护：</h3>
              <ul class="qsn-page__features-list">
                <li class="qsn-page__feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                  <span>为保障未成年人充足睡眠，夜间时段（如22：00至次日6：00）默认不可使用。</span>
                </li>
                <li class="qsn-page__feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                  </svg>
                  <span>开启青少年模式后，系统将自动过滤不适合青少年接触的内容，只呈现积极、健康、优质的音乐作品和相关资讯，同时合理控制使用时长，帮助孩子养成良好的听歌习惯。</span>
                </li>
                <li class="qsn-page__feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                  <span>在青少年模式中，不可进行充值、付费等操作。</span>
                </li>
              </ul>
            </div>
            
            <div class="qsn-page__form">
                <div class="qsn-page__form-group">
                  <label class="qsn-page__form-label">请设置青少年密码 <span class="qsn-page__required">*</span></label>
                  <input type="password" class="qsn-page__form-input" v-model="verifyForm.password" placeholder="请设置青少年模式独立密码" autocomplete="new-password" />
                </div>
                <div class="qsn-page__form-group">
                  <label class="qsn-page__form-label">确认密码 <span class="qsn-page__required">*</span></label>
                  <input type="password" class="qsn-page__form-input" v-model="verifyForm.confirmPassword" placeholder="请再次输入密码" autocomplete="new-password" />
                </div>
                <button class="qsn-page__submit-btn" @click="enableTeenMode">开启青少年模式</button>
              </div>
          </div>
          
          <div v-else-if="isLoggedIn">
            <div class="qsn-page__active-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h3 class="qsn-page__active-title">青少年模式已开启</h3>
            <p class="qsn-page__active-desc">当前已处于青少年保护模式下，您的使用将受到相应限制。如需关闭，请输入账号密码验证。</p>
            
            <!-- <div class="qsn-page__usage">
              <div class="qsn-page__usage-item">
                <span class="qsn-page__usage-num">2</span>
                <span class="qsn-page__usage-unit">小时</span>
                <span class="qsn-page__usage-label">今日剩余时长</span>
              </div>
              <div class="qsn-page__usage-divider"></div>
              <div class="qsn-page__usage-item">
                <span class="qsn-page__usage-num">120</span>
                <span class="qsn-page__usage-unit">首</span>
                <span class="qsn-page__usage-label">今日已听歌曲</span>
              </div>
            </div> -->
            
            <div class="qsn-page__form">
              <div class="qsn-page__form-group">
                <label class="qsn-page__form-label">密码 <span class="qsn-page__required">*</span></label>
                <input type="password" class="qsn-page__form-input" v-model="verifyForm.password" placeholder="请输入密码" autocomplete="new-password" />
              </div>
              <button class="qsn-page__submit-btn qsn-page__submit-btn--danger" @click="disableTeenMode">关闭青少年模式</button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="qsn-page__tips">
        <h3 class="qsn-page__tips-title">温馨提示</h3>
        <ul class="qsn-page__tips-list">
          <li>青少年模式仅适用于当前登录账号</li>
          <li>开启后所有设备登录该账号均受限制</li>
          <li>开启青少年模式，需先设置独立密码，如忘记密码可通过申诉重置密码。</li>
          <li>青少年模式是yours为促进青少年健康成长作出的一次尝试，我们优先针对核心场景进行了优化，也将继续致力于优化更多场景。</li>
          <li>如有疑问请联系客服：18519373645</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Qsn',
  data() {
    return {
      isTeenMode: false,
      verifyForm: {
        password: '',
        confirmPassword: ''
      },
      isLoggedIn: false
    }
  },
  created() {
    this.checkLoginStatus()
    this.loadTeenModeStatus()
  },
  methods: {
    checkLoginStatus() {
      const savedUser = localStorage.getItem('YousrDL')
      this.isLoggedIn = !!savedUser
    },
    loadTeenModeStatus() {
      // 未登录时，显示未开启
      if (!this.isLoggedIn) {
        this.isTeenMode = false
        return
      }
      // 已登录时，检查是否有teenPassword
      const teenPassword = localStorage.getItem('teenPassword')
      this.isTeenMode = !!teenPassword
    },
    // saveTeenModeStatus(status) {
    //   // 通过teenPassword的存在来判断状态，不需要额外存储isTeenMode
    //   // 这个方法保留用于兼容性，实际状态由teenPassword决定
    // },
    enableTeenMode() {
      if (!this.isLoggedIn) {
        alert('请先登录')
        return
      }

      if (!this.verifyForm.password) {
        alert('请设置青少年密码')
        return
      }

      if (this.verifyForm.password.length < 6) {
        alert('密码长度不能少于6位')
        return
      }

      if (!this.verifyForm.confirmPassword) {
        alert('请确认密码')
        return
      }

      if (this.verifyForm.password !== this.verifyForm.confirmPassword) {
        alert('两次输入的密码不一致')
        return
      }

      localStorage.setItem('teenPassword', this.verifyForm.password)
      this.isTeenMode = true
      alert('青少年模式已开启，感谢您对青少年健康的关注')
      this.verifyForm.password = ''
      this.verifyForm.confirmPassword = ''
    },
    disableTeenMode() {
      const savedPassword = localStorage.getItem('teenPassword')
      if (!savedPassword) {
        alert('未设置青少年密码')
        return
      }

      if (!this.verifyForm.password) {
        alert('请输入密码')
        return
      }

      if (this.verifyForm.password !== savedPassword) {
        alert('密码错误')
        return
      }

      localStorage.removeItem('teenPassword')
      this.isTeenMode = false
      alert('青少年模式已关闭，您可以正常使用所有功能')
      this.verifyForm.password = ''
    }
  }
}
</script>

<style scoped lang="scss">
.qsn-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #6b2a2a 0%, #9a1f13 100%);
  padding: 40px 20px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.qsn-page__container {
  max-width: 500px;
  margin: 0 auto;
}

.qsn-page__title {
  font-size: 28px;
  font-weight: 300;
  color: #ffffff;
  text-align: center;
  margin: 0 0 30px 0;
}

.qsn-page__card {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.qsn-page__card-header {
  background-color: rgba(243, 112, 33, 0.2);
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.qsn-page__status {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  
  &--active {
    color: #f37021;
  }
}

.qsn-page__status-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  
  .qsn-page__status--active & {
    background-color: #f37021;
    box-shadow: 0 0 10px rgba(243, 112, 33, 0.5);
  }
}

.qsn-page__card-body {
  padding: 24px;
}

.qsn-page__desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 0 0 20px 0;
}

.qsn-page__features {
  margin-bottom: 24px;
}

.qsn-page__features-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 12px 0;
}

.qsn-page__features-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.qsn-page__feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  
  svg {
    width: 18px;
    height: 18px;
    color: #f37021;
    flex-shrink: 0;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.qsn-page__form {
  margin-top: 20px;
}

.qsn-page__form-group {
  margin-bottom: 16px;
}

.qsn-page__form-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 6px 0;
}

.qsn-page__required {
  color: #f37021;
}

.qsn-page__form-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  transition: all 0.2s;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    background-color: rgba(0, 0, 0, 0.35);
  }
}

.qsn-page__submit-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 6px;
  background-color: #f37021;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #d95e12;
  }
  
  &--danger {
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
}

.qsn-page__active-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  background-color: rgba(243, 112, 33, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 40px;
    height: 40px;
    color: #f37021;
  }
}

.qsn-page__active-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  margin: 0 0 8px 0;
}

.qsn-page__active-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.qsn-page__usage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  margin-bottom: 24px;
}

.qsn-page__usage-item {
  text-align: center;
}

.qsn-page__usage-num {
  font-size: 28px;
  font-weight: bold;
  color: #f37021;
  display: block;
}

.qsn-page__usage-unit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-left: 2px;
}

.qsn-page__usage-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-top: 4px;
}

.qsn-page__usage-divider {
  width: 1px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
}

.qsn-page__tips {
  margin-top: 24px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.qsn-page__login-tip {
  text-align: center;
  padding: 40px 20px;
  
  svg {
    width: 64px;
    height: 64px;
    color: rgba(255, 255, 255, 0.3);
    margin-bottom: 16px;
  }
  
  p {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 8px 0;
  }
}

.qsn-page__login-tip-desc {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.6) !important;
}

.qsn-page__tips-title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 12px 0;
}

.qsn-page__tips-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.qsn-page__tips-list li {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  padding: 6px 0;
  position: relative;
  padding-left: 16px;
  
  &::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #f37021;
  }
}
</style>